__turbopack_context__.v({
  "tableContainer": "IndicatorTable-web-modal-module__xs3k0G__tableContainer",
});
